import React from 'react';
import { Col, Grid, Row } from 'tidee-life-ui/dist/src/grid.js';
import Spacing from 'tidee-life-ui/dist/src/spacing.js';
import MainLogo from '../logo/main-logo.tsx';

import { paths as corePaths } from 'tidee-life-core';

interface TemplateAProps {
    children?: React.ReactNode;
}

const TemplateA: React.FC<TemplateAProps> = ({ children }) => {
    return (
        <Grid data-testid="page-template">
            <Row center="xs">
                <Col xs={12}>
                    <Spacing
                        align="center"
                        padding={['xl', null, 'xl', null]}
                        width={350}
                    >
                        <MainLogo link={corePaths.login()} />
                        {children}
                    </Spacing>
                </Col>
            </Row>
        </Grid>
    );
};

export default TemplateA;
